// Utility function to format invoice number based on configuration
export const formatInvoiceNumber = (invoiceNumber, financialYear, config) => {
  const format = config?.invoiceNumberFormat || 'YYYY-YYYY/###';
  
  // Parse financial year (e.g., "2024-2025" -> startYear: 2024, endYear: 2025)
  const yearParts = financialYear.split('-');
  const startYear = yearParts[0];
  const endYear = yearParts[1];
  
  // Pad invoice number with zeros (assuming ### means 3 digits)
  const hashCount = (format.match(/#/g) || []).length;
  const paddedNumber = String(invoiceNumber).padStart(hashCount || 3, '0');
  
  let formattedNumber = format;
  
  // Check if the format already contains actual years (like "2025-26/###")
  // If so, replace the existing year with the new financial year
  const yearPattern = /\d{4}-\d{2,4}/;
  if (yearPattern.test(formattedNumber)) {
    // Replace existing year pattern with new financial year
    formattedNumber = formattedNumber.replace(yearPattern, `${startYear}-${endYear.slice(-2)}`);
  } else {
    // Replace YYYY-YYYY with full financial year
    formattedNumber = formattedNumber.replace('YYYY-YYYY', `${startYear}-${endYear}`);
    
    // Replace YYYY-YY with start year and 2-digit end year
    formattedNumber = formattedNumber.replace('YYYY-YY', `${startYear}-${endYear.slice(-2)}`);
  }
  
  // Replace ### with padded invoice number
  formattedNumber = formattedNumber.replace(/#+/g, paddedNumber);
  
  return formattedNumber;
}; 